// extracted by mini-css-extract-plugin
module.exports = {"button":"ToTopButton-module--button--2IHl0"};